import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { ProjectsIcon } from '@atlaskit/logo';

import type { FallbackUrl, GlobalShortcutsItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <ProjectsIcon size="xsmall" shouldUseNewLogoDesign />;

/**
 * @private
 * @deprecated Please use `useProjects` instead
 */
export default function projects(fallbackUrl: FallbackUrl): GlobalShortcutsItem {
	const label = FeatureGates.getExperimentValue('project-terminology-refresh', 'isEnabled', false)
		? messages.labelGalaxia
		: messages.label;

	return {
		icon,
		// The i18n unfriendly default value of `label` is why this function is deprecated.
		// `labelElem` will be used instead of `label` in most places, but `label` will still be used in some places like customization modal.
		// For an i18n friendly default value of `label`, please use `useProjects` instead.
		label: 'Projects',
		labelElem: <FormattedMessage {...label} />,
		fallbackUrl,
	};
}

export const useProjects = (fallbackUrl: FallbackUrl) => {
	const label = FeatureGates.getExperimentValue('project-terminology-refresh', 'isEnabled', false)
		? messages.labelGalaxia
		: messages.label;

	return useAppGlobalShortcutLinkItem(icon, label, fallbackUrl);
};
